import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Loading } from "@/components/common";
import { UsersManager } from "@/components/UsersManager";
import { PermMatrix } from "@/components/PermMatrix";
import { CollectorAssign } from "@/components/CollectorAssign";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

function TenantUserList() {
  const { user } = useAuth();
  const [roles, setRoles] = useState(null);
  useEffect(() => {
    api.get("/roles/options").then((r) => setRoles(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  if (!roles) return <Loading />;
  return <UsersManager apiBase="/users" roles={roles} lockedRoles={user?.platform_role ? [] : ["owner"]} />;
}

export default function TenantUsers() {
  const { can } = useAuth();
  return (
    <div>
      <PageHeader sheet="SHEET 11" title="Manajemen Pengguna" subtitle="Tambahkan pengguna untuk unit usaha Anda dan atur hak akses tiap level, termasuk level kustom. Pemilik selalu memiliki akses penuh." />
      <Tabs defaultValue="users">
        <TabsList>
          <TabsTrigger value="users" data-testid="tab-users">Pengguna</TabsTrigger>
          {can("role:manage") && <TabsTrigger value="perms" data-testid="tab-perms">Atur Hak Akses</TabsTrigger>}
          <TabsTrigger value="collectors" data-testid="tab-collectors">Petugas Penarikan</TabsTrigger>
        </TabsList>
        <TabsContent value="users" className="mt-4"><TenantUserList /></TabsContent>
        {can("role:manage") && <TabsContent value="perms" className="mt-4"><PermMatrix url="/roles/perms" manageCustom /></TabsContent>}
        <TabsContent value="collectors" className="mt-4"><CollectorAssign /></TabsContent>
      </Tabs>
    </div>
  );
}
